import React from "react";
import { Link } from "react-router-dom";
// import { useState } from "react";
import "./UnLinkActionButton.css";
// import Breadcrumb from '../../../Layout/Breadcrumb/Breadcrumb';
// import Header from '../../../Layout/Header/Header';
// import Footer from '../../../Layout/Footer/Footer';
// import Nav from '../../../Layout/Nav/Nav';
// import LoginImage from '../../../Images/login.jpg';

function UnLinkActionButton(props) {
  //   const [iconButtonsStore, seticonButtonsStore] = useState(iconButtons);

  const UnLinkActionButton = [
    {
      id: 1,
      enable: 1,
      name: "edit",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-edit"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160L0 416c0 53 43 96 96 96l256 0c53 0 96-43 96-96l0-96c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 96c0 17.7-14.3 32-32 32L96 448c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l96 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 64z" />
            </svg>
          </div>
        </button>
      ),
    },

    {
      id: 2,
      enable: 1,
      name: "view",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-view"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
            </svg>
          </div>
        </button>
      ),
    },

    {
      id: 3,
      enable: 1,
      name: "disable",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-disable"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"
            >
              <path d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z" />
            </svg>
          </div>
        </button>
      ),
    },

    {
      id: 4,
      enable: 1,
      name: "enable",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-enable"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"></path>
            </svg>
          </div>
        </button>
      ),
    },

    {
      id: 5,
      enable: 1,
      name: "close",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-close"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 384 512"
            >
              <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path>
            </svg>
          </div>
        </button>
      ),
    },

    {
      id: 6,
      enable: 1,
      name: "add_subscriber",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-add_subscriber"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 640 512"
            >
              <path d="M96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3zM504 312l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z"></path>
            </svg>
          </div>
        </button>
      ),
    },

    {
      id: 7,
      enable: 1,
      name: "add",
      button: (
        <button
        onClick={()=>{
          props.trigerClick();
          props.modalStateAndValue && props.modalStateAndValue.setState(props.modalStateAndValue.setStateValue);
        }}
          type="button"
          className="icon-button-elmt icon-button-elmt-add"
        >
          <div className="icon-button-elmt-c-sec">
            <svg
              className="icon-button-elmt-c-icon-elmt"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 448 512"
            >
              <path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z"></path>
            </svg>
          </div>
        </button>
      ),
    },
  ];

  return UnLinkActionButton
    .filter((ibtn) => ibtn.name == props.btnname && ibtn.enable == 1)
    .map((filteredIbtn) => (
      <span key={filteredIbtn.id}>{filteredIbtn.button}</span>
    ));
}
export default UnLinkActionButton;
